module.exports = __webpack_public_path__ + "img/bluesky3100_30.81e95b82.jpg";